import { IconButton } from "@mui/material";
import { ArrowLeft } from "lucide-react";
import React from "react";
import RenderText from "../Text/RenderText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

interface IProps {
  onBack?: () => void;
  backBtn?: boolean;
  title: string;
  className?: string;
  id?: string;
  icon?: React.ReactNode;
  shadow?: boolean;
  innerClassName?: string;
  closeBtn?: boolean;
  onClose?: () => void;
  backBtnClassName?: string;
  rippleEffect?: boolean;
}

const DrawerTitle: React.FC<IProps> = ({
  title,
  backBtn,
  onBack,
  className,
  id,
  icon,
  shadow = true,
  innerClassName,
  closeBtn = false,
  onClose,
  backBtnClassName,
  rippleEffect = true,
}) => {
  return (
    <div
      className={`w-full h-fit sticky top-0 z-[20] bg-white ${className}`}
      id="drawwer-title"
    >
      <div
        className={`w-full relative ${
          shadow ? "shadow-md" : ""
        } bg-white flex items-center justify-center 2xl:py-4 py-3 ${innerClassName}`}
      >
        {backBtn && (
          <div className={`absolute left-2 ${backBtnClassName}`}>
            <IconButton
              onClick={onBack}
              className="2xl:w-[40px] 2xl:h-[40px] w-[30px] h-[30px]"
              id={"back-button"}
              disableRipple={!rippleEffect}
            >
              <FontAwesomeIcon
                icon={faArrowLeft}
                className="theme-color-green-dark font-size-17px"
              />
            </IconButton>
          </div>
        )}
        <RenderText className="font-Poppins-Medium font-size-18px flex items-center gap-2 text-[#2F2F31]">
          {icon}
          {title}
        </RenderText>
      </div>
    </div>
  );
};

export default DrawerTitle;
